import styled from 'styled-components';

export const Container = styled.span`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;
